export enum EditorMode {
  Edit = 'edit',
  SourceCode = 'source-code',
  Preview = 'preview',
  Design = 'design'
};
